import { render, staticRenderFns } from "./PorEquipeAcs.vue?vue&type=template&id=87121d86&scoped=true"
import script from "./PorEquipeAcs.vue?vue&type=script&lang=js"
export * from "./PorEquipeAcs.vue?vue&type=script&lang=js"
import style0 from "./PorEquipeAcs.vue?vue&type=style&index=0&id=87121d86&prod&scoped=true&lang=css"
import style1 from "./PorEquipeAcs.vue?vue&type=style&index=1&id=87121d86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87121d86",
  null
  
)

export default component.exports